module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti-5792159e3bd54193aba090719390f2a4.jpg";